module.exports = __webpack_public_path__ + "img/check-lead.bcd6bf48.svg";